var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../../Touchable"));

var _LoadingSpinner = _interopRequireDefault(require("../../LoadingSpinner"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/Button/Loading/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LoadingButton = function (_React$PureComponent) {
  (0, _inherits2.default)(LoadingButton, _React$PureComponent);

  var _super = _createSuper(LoadingButton);

  function LoadingButton() {
    var _this;

    (0, _classCallCheck2.default)(this, LoadingButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderButton = function () {
      return _react.default.createElement(_Basic.View, {
        borderBottom: 1,
        borderColor: "font.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16,
          columnNumber: 9
        }
      }, _react.default.createElement(_Basic.Text, {
        color: "font.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 17,
          columnNumber: 13
        }
      }, _this.props.label));
    };

    return _this;
  }

  (0, _createClass2.default)(LoadingButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isLoading = _this$props.isLoading,
          renderButton = _this$props.renderButton,
          _onPress = _this$props.onPress;
      return isLoading ? _react.default.createElement(_LoadingSpinner.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 25,
          columnNumber: 13
        }
      }) : _react.default.createElement(_Touchable.default, {
        onPress: function onPress() {
          return _onPress();
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27,
          columnNumber: 13
        }
      }, typeof renderButton === 'function' ? renderButton() : this.renderButton());
    }
  }]);
  return LoadingButton;
}(_react.default.PureComponent);

LoadingButton.propTypes = {
  onPress: _propTypes.default.func.isRequired,
  isLoading: _propTypes.default.bool,
  label: _propTypes.default.string,
  renderButton: _propTypes.default.func
};
var _default = LoadingButton;
exports.default = _default;